import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PAY_ROUTE } from 'constants/index';

const RedirectToPay = (props: { cleanSearch?: boolean }) => {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const route = props.cleanSearch ? PAY_ROUTE : PAY_ROUTE + search;
    navigate(route);
  }, [navigate, search, props.cleanSearch]);

  return null;
};

export { RedirectToPay };
